module.exports = __webpack_public_path__ + "images/corners/Kobe.3847c2107ef276da4d13340347477bbc.jpg";